import React, {PureComponent} from 'react';
import HttpUtils from '../../utils/http';

class EstheticianNodeModel extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            esthAddNode:'notes',
            selectPick:'esthetician',
            estheticianNodeValue: this.props.estheticianNodeValue,
            _estheticianNodeValue: this.props.estheticianNodeValue,
            isOpen:false,
            isPickOpen:false,
        };

        this.handleEditNoteEdit = this.handleEditNoteEdit.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handlePickOpen = this.handlePickOpen.bind(this);
    }

    // noNotesRadio

    componentDidUpdate(prevProps, prevState){
        if(prevProps.estheticianNodeValue != this.state._estheticianNodeValue){
            this.setState({
                estheticianNodeValue: this.props.estheticianNodeValue,
                _estheticianNodeValue:this.props.estheticianNodeValue,
            });
        }
    }

    handleOpen(){
        this.setState({
            isOpen: !this.state.isOpen,
            isPickOpen: false,
            esthAddNode:'notes',
        },()=>{  
            this.refs.myNotes.checked=true;
        });
    }

    handlePickOpen(){
        this.setState({
            isPickOpen: true
        });
    }

    handleEditNoteEdit(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value },()=>{
            
            let isEstheticianPick = false;
            if(this.state.selectPick == "esthetician"){
                isEstheticianPick = true
            }
        });
    }

    fun_submitDataServer(isEstheticianPick){
        const userId = this.props.userId;
        const productId = this.props.id;
        let estheticianNodeValue = this.state.estheticianNodeValue;


        if(isEstheticianPick == false || this.state.esthAddNode == "noNotes" ){
            estheticianNodeValue = ''
            this.setState({
                estheticianNodeValue:''
            });
        }

        this.setState({
            isOpen:false,
        });

        HttpUtils.post("/api/portal-esthetician-picks",{
            userId: userId,
            productId: productId,
            note:estheticianNodeValue,
            isEstheticianPick:isEstheticianPick,
        }).then(()=>{
            this.props.handlePickSubmitChangeData(isEstheticianPick,estheticianNodeValue);
        })
    }


   

    render() {
        return (
            <div style={{width:'100%'}}>
                <div className="es-picks-area-title-label esthe_pick_type" style={{flexDirection: 'column'}}>
                    <div className="estheticianTitleModel" onClick={this.handleOpen}>
                        <img className="dialogue-img" src="../../../images/explain/icont/dialogue.png"/>
                        <span>Esthetician’s pick</span>
                        <i className={this.state.isOpen ? "fa fa-angle-up fa-fw fa-arrea" : "fa fa-angle-down fa-fw fa-arrea"} ></i>
                    </div>

                    <div style={ this.state.isOpen ? {width:'100%',display:'block'} : {width:'100%',display:'none'}}>
                        <div style={this.state.esthAddNode == 'notes' ? {display:'block'}:{display:'none'}  }>
                            <textarea onClick={this.handlePickOpen} onChange={this.handleEditNoteEdit} name="estheticianNodeValue" value={this.state.estheticianNodeValue} className="inputNode_area_textArea paragraphRegular4 esthei-node-input"></textarea>
                        </div>

                        <div className="select-picks-content" style={ this.state.isPickOpen ? {display:'block'} : {display:'none'}}>
                            <ul className="select-picks-content-ul esthetician-li-select" style={{marginTop:'4px'}}>
                                <li>
                                    <div className="esthetician-selectNote">
                                        <label>
                                            <input type="radio" ref="myNotes" name="esthAddNode" value = 'notes' onChange={this.handleEditNoteEdit}></input> 
                                             Notes
                                        </label>
                                        
                                        <label>
                                            <input type="radio" ref="myNoNotes" name="esthAddNode" value ='noNotes' onChange={this.handleEditNoteEdit}></input> 
                                            No notes
                                        </label>
                                        <div style={{marginTop:'7px'}}> <button style={{backgroundColor:'#272D67'}} className="inputNode_area_button" onClick={()=>{ this.fun_submitDataServer() }}>Save</button> </div>
                                    </div>
                                </li>
                                
                            </ul>
                            <div onClick={()=>{ this.fun_submitDataServer(false)}} name="selectPick" value="none" className="esthetician-select-none">None</div>
                        </div>

                    </div>

                </div>
            </div>
            
        );
    }
}

export default EstheticianNodeModel;



// WEBPACK FOOTER //
// ./src/components/customersuccessportal/EstheticianNodeModel.js